import React from 'react';
import { Navbar, Nav, NavDropdown, Container, Dropdown } from 'react-bootstrap';
import {FaHeart, FaHome, FaInfo, FaNewspaper, FaPenSquare} from "react-icons/fa";

const NavBar = ({isMenuOpen, onMenuToggle, handleHome, handleServices, handleAbout, handleContact, handleSignUp, handleTestimonial, setNavLinks}) => {
  return (

    
<Navbar collapseOnSelect expand="sm" className='custom-navBar'>
      <Container fluid className='ms-1 me-1'>
     
        <Navbar.Brand onClick={handleHome} className='brand-img-container'><img  className='w-100 h-100' src={require("../Images/logo3.png")} alt="" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav"  onClick={onMenuToggle}/>
        <Navbar.Collapse id="responsive-navbar-nav" in={isMenuOpen}>
          <Nav >
            <Nav.Link  className='d-flex gap-1' onClick={handleHome}> <FaHome />  Home</Nav.Link>
            <Nav.Link  className='d-flex gap-1' onClick={handleAbout}> <FaInfo /> About</Nav.Link>
            <NavDropdown title="Services" id="collasible-nav-dropdown">

              <NavDropdown.Item  onClick={handleServices}> All Services </NavDropdown.Item>
              <Dropdown.Divider/>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairServicesLink: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink: true}));
                }}>Hair Collections</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairServicesLink1: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink1: true}));
                }}>Weavon Collections</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairServicesLink2: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink2: true}));
                }}>Crochet Collections</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairServicesLink3: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink3: true}));
                }}>Revamp & Restyle Collections</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairServicesLink4: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink4: true}));
                }}>Braid Collections</NavDropdown.Item>
              <Dropdown.Divider/>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({hairAccessoriesLink: true})
                sessionStorage.setItem("currentSession", JSON.stringify({hairAccessoriesLink: true}));
                }}>Hair Accessories</NavDropdown.Item>
              <Dropdown.Divider/>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({appWebDevLink: true})
                sessionStorage.setItem("currentSession", JSON.stringify({appWebDevLink: true}));
                }}>  App & Web Dev</NavDropdown.Item>
              <Dropdown.Divider/>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({graphicDesignLink: true})
                sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink: true}));
                }}>E-Flyers Design</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({graphicDesignLink1: true})
                sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink1: true}));
                }}>3D Logos Design</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({graphicDesignLink2: true})
                sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink2: true}));
                }}>Banners & Letter Heads Design</NavDropdown.Item>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({graphicDesignLink3: true})
                sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink3: true}));
                }}>Branding & Identity Cards Design</NavDropdown.Item>
              <Dropdown.Divider/>
              <NavDropdown.Item  onClick={()=>{
                setNavLinks({trainingLink: true})
                sessionStorage.setItem("currentSession", JSON.stringify({trainingLink: true}));
                }}>Training School</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav className='ms-auto'>
            <Nav.Link href="#" className='d-flex gap-1' onClick={handleContact}> <FaPenSquare /> Support</Nav.Link>
            <Nav.Link href="#" className='d-flex gap-1' onClick={handleSignUp}> <FaNewspaper /> Newsletter</Nav.Link>
            <Nav.Link href="#" className='d-flex gap-1' onClick={handleTestimonial}> <FaHeart /> Testimonial</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

  )
      
  }


export default NavBar;